import metaSchemaResolver from '.';

const faqResolver = ({ question, answer }) => ({
  '@type': 'Question',
  name: question,
  acceptedAnswer: {
    '@type': 'Answer',
    text: answer,
  },
});

export const faqsMetaResolver = (faqs) =>
  faqs && {
    mainEntity: faqs.map(faqResolver),
  };

export default (faqs) => [
  metaSchemaResolver(faqsMetaResolver(faqs), 'FAQPage'),
];
